import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  (theme) => ({
    cancelMembership: {
      height: '100vh',
      width: '100%',
      padding: '42px 64px 18px 64px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      maxWidth: '1080px',
      // overflowY: 'auto',
      // wordSpacing: '0.3em',

      [theme.breakpoints.down('md')]: {
        height: 'calc(100vh - 106px)', // prevents awkward scroll
        // padding: '24px 12px',
        padding: '0',
        gap: '20px',
      },
    },
    cancelMembershipContent: {
      width: '100%',
    },
    cancelMembershipPage: {
      display: 'flex',
      width: '100%',
      gap: '20px',
      marginBottom: '40px',

      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        gap: '40px',
      },
    },
    contentLeft: {
      width: '100%',
      minWidth: '300px',
    },
    header: {
      display: 'flex',
      flexDirection: 'column',
      paddingBottom: '40px',
    },
    pageSelector: {
      width: 'fit-content',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '15px',
      padding: '8px 16px',
      borderRadius: '50px',
      lineHeight: '16px',
      border: `1px solid ${theme.colors.smoke}`,
    },

    // Image
    contentRight: {
      width: '60%',
      maxWidth: '500px',
      marginTop: '18px',
      flexShrink: 0,

      [theme.breakpoints.down('md')]: {
        width: '100%',
        maxWidth: '500px',
        flexShrink: 1,
      },
    },

    // Page specific
    title: {
      fontSize: '44px',
      lineHeight: '1.35',
      maxWidth: '620px',
    },
    mainContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '34px',
      lineHeight: '1.4',
    },

    // Footer
    footer: {
      // outline: '1px solid black',
      width: '100%',
      height: '64px',
      paddingBottom: '20px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      gap: '20px',

      [theme.breakpoints.down('sm')]: {
        flexWrap: 'wrap',
        height: 'fit-content',
        justifyContent: 'center',
        alignItems: 'center',
      },
    },
    footerLeft: {
      display: 'flex',
      gap: '12px',
    },
    footerRight: {
      display: 'flex',
      justifyContent: 'center',
      gap: '12px',
    },
    continueButton: {
      display: 'flex',
      justifyContent: 'center',
      fontSize: '16px',
      fontWeight: theme.fontWeights.medium,
      color: theme.colors.charcoal,
      gap: '20px',
    },
    continueButtonText: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '18px',
    },
    continueArrow: {
      width: '35px',
      height: '28px',
      borderRadius: '50px',
      backgroundColor: '#FAE7AA',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      // padding: '8px 10px 8px 8px',
    },
  }),
  { name: 'CancelMembership' },
);

export default useStyles;

export const primaryButtonStyles = {
  button: {
    fontSize: '18px',
  },
};
